var modules_eba0b2d9 = {"menu":"UserMenu_module_menu__0a49c186","item":"UserMenu_module_item__0a49c186","divider":"UserMenu_module_divider__0a49c186","dark":"UserMenu_module_dark__0a49c186"};
import "../../../assets/esm/components/UserMenu/src/UserMenu~D4ro-mbv.css";

export { modules_eba0b2d9 as default };
//# sourceMappingURL=UserMenu.module.less.js.map
